export class ProductCarousel
{
	public CarouselID;
	public CarouselTitle;
	public Products;

	constructor(carouselID, carouselTitle, products)
	{
		this.CarouselID = carouselID;
		this.CarouselTitle = carouselTitle;
		this.Products = products;
	}
}